module.exports = __webpack_public_path__ + "img/empreendimento-logo-1.163ac780.png";